module.exports = __webpack_public_path__ + "static/img/report_img_bjstfxpgbg.764ade6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_bjstfxpgbg.png
// module id = 58WV
// module chunks = 21